/*
 * <combo-plan-selector> — plan-card combo số-lượng trong buy-box (UI kiểu Coterie).
 * Card = gói N của CHÍNH sản phẩm đang xem. Chọn card → set quantity + property "Gói"
 * + nhãn CTA "Thêm combo · [giá gói]". Variant id đồng bộ từ form mua chính (Dawn luôn
 * giữ [name=id] đúng variant đang chọn) tại lúc chọn card VÀ lúc bấm nút (click chạy
 * trước submit) — đổi size/loại SP là combo ăn theo, không cần chip size riêng.
 * Gate "Chọn size"/"Đã bán hết" do pdp-atc-size-label.js quản (nó đọc data-ready-label
 * để khôi phục nhãn khi mở khoá). Custom element nên tự bind lại nếu buy-box re-render.
 */
(function () {
  class ComboPlanSelector extends HTMLElement {
    connectedCallback() {
      this.addLabel = this.dataset.addLabel || 'Thêm combo';
      this.mainFormId = this.dataset.mainForm;
      this.idInput = this.querySelector('[data-combo-variant-id]');
      this.qtyInput = this.querySelector('[data-combo-qty]');
      this.propInput = this.querySelector('[data-combo-prop]');
      this.submitBtn = this.querySelector('.combo-plan__submit');
      this.submitLabel = this.submitBtn ? this.submitBtn.querySelector('span') : null;

      this.onChange = this.onChange.bind(this);
      this.onSubmitClick = this.onSubmitClick.bind(this);
      this.addEventListener('change', this.onChange);
      if (this.submitBtn) this.submitBtn.addEventListener('click', this.onSubmitClick);

      var checked = this.querySelector('.combo-plan__radio:checked');
      if (checked) this.applyTier(checked);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      if (this.submitBtn) this.submitBtn.removeEventListener('click', this.onSubmitClick);
    }

    onChange(event) {
      if (event.target && event.target.matches && event.target.matches('.combo-plan__radio')) {
        this.applyTier(event.target);
      }
    }

    // Click chạy TRƯỚC submit của product-form → chốt variant id đúng lựa chọn hiện tại.
    onSubmitClick() {
      this.syncVariantFromMain();
    }

    applyTier(radio) {
      var qty = parseInt(radio.dataset.qty, 10) || 1;
      if (this.qtyInput) this.qtyInput.value = qty;
      if (this.propInput) {
        // Gói 1 (mua lẻ) → không ghi property "Gói" vào giỏ (input disabled bị loại khỏi FormData)
        this.propInput.value = radio.value;
        this.propInput.disabled = qty === 1;
      }

      var prefix = radio.dataset.labelPrefix || this.addLabel;
      var ready = prefix + (radio.dataset.price ? ' · ' + radio.dataset.price : '');
      if (this.submitBtn) {
        // Nhãn "sẵn sàng" cho pdp-atc-size-label khôi phục sau khi user chọn size xong.
        this.submitBtn.dataset.readyLabel = ready;
        if (!this.submitBtn.hasAttribute('disabled') && this.submitLabel) {
          this.submitLabel.textContent = ready;
        }
      }
      this.syncVariantFromMain();
    }

    syncVariantFromMain() {
      if (!this.idInput || !this.mainFormId) return;
      var mainForm = document.getElementById(this.mainFormId);
      var mainId = mainForm && mainForm.querySelector('input[name="id"]');
      if (mainId && mainId.value) this.idInput.value = mainId.value;
    }
  }

  if (!customElements.get('combo-plan-selector')) {
    customElements.define('combo-plan-selector', ComboPlanSelector);
  }
})();
